import { useState, useEffect } from 'react';
import type { PlaycastHostOneGamepadState } from '@playcastdotio/CoreTypes';
import type { AppCoordinator } from '../../app/AppCoordinator';

/**
 * Reactive hook for physical host gamepads.
 * Subscribes to AppCoordinator.events.hostGamepadsChanged.
 */
export function useHostGamepads(coordinator: AppCoordinator): PlaycastHostOneGamepadState[] {
  const [gamepads, setGamepads] = useState<PlaycastHostOneGamepadState[]>(
    () => coordinator.getHostGamepads(),
  );

  useEffect(() => {
    return coordinator.events.hostGamepadsChanged.addListener(setGamepads);
  }, [coordinator]);

  return gamepads;
}
